import { apiClient } from './client';

export function getWebhooks (shopId: number | string) {
  return apiClient.get(`/${shopId}/webhooks`);
}

export function fireWebhook (shopId: number | string, webhookId: number | string, payload: Record<string, unknown>) {
  return apiClient.post(`/${shopId}/webhooks/${webhookId}/fire`, payload);
}

export function bulkFireWebhooks (shopId: number | string, payload: { return_ids: number[]; topic: string; trigger: string }) {
  return apiClient.post(`/${shopId}/webhooks/bulk-fire`, payload);
}
